import { render, staticRenderFns } from "./PlaceDetailPage.vue?vue&type=template&id=1d91ee40"
import script from "./PlaceDetailPage.vue?vue&type=script&lang=js"
export * from "./PlaceDetailPage.vue?vue&type=script&lang=js"
import style0 from "./PlaceDetailPage.vue?vue&type=style&index=0&id=1d91ee40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports